import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "list-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_TableList = _resolveComponent("TableList")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives((_openBlock(), _createBlock(_component_TableList, {
      ref: "TableList",
      dataList: _ctx.list,
      total: _ctx.total,
      page: _ctx.listQuery.page,
      size: _ctx.listQuery.size,
      columnAllData: _ctx.columnAllData,
      tableName: _ctx.TableName,
      permissionName: _ctx.permissionName,
      showSelection: true,
      canCommand: false,
      canChangeColumn: false,
      isShowPagination: false,
      onCommandChange: _ctx.handleCommand
    }, {
      max: _withCtx((scope) => [
        _createElementVNode("span", null, [
          (scope.row.max)
            ? (_openBlock(), _createBlock(_component_el_tooltip, {
                key: 0,
                effect: "dark",
                placement: "top-start"
              }, {
                content: _withCtx(() => [
                  _createTextVNode(_toDisplayString(scope.row.max?.supplier?.name), 1),
                  _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1)),
                  _createTextVNode(" 最后修改时间：" + _toDisplayString(scope.row.max?.updateTime), 1)
                ]),
                default: _withCtx(() => [
                  _cache[1] || (_cache[1] = _createElementVNode("i", {
                    class: "iconfont icon-tubiao-30",
                    style: {"font-size":"14px"}
                  }, null, -1))
                ]),
                _: 2
              }, 1024))
            : _createCommentVNode("", true),
          _createTextVNode(" " + _toDisplayString(_ctx.maxMinCalc(scope.row, 'max')), 1)
        ])
      ]),
      min: _withCtx((scope) => [
        _createElementVNode("span", null, [
          (scope.row.min)
            ? (_openBlock(), _createBlock(_component_el_tooltip, {
                key: 0,
                effect: "dark",
                placement: "top-start"
              }, {
                content: _withCtx(() => [
                  _createTextVNode(_toDisplayString(scope.row.max?.supplier?.name), 1),
                  _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)),
                  _createTextVNode(" 最后修改时间：" + _toDisplayString(scope.row.min?.updateTime), 1)
                ]),
                default: _withCtx(() => [
                  _cache[3] || (_cache[3] = _createElementVNode("i", {
                    class: "iconfont icon-tubiao-30",
                    style: {"font-size":"14px"}
                  }, null, -1))
                ]),
                _: 2
              }, 1024))
            : _createCommentVNode("", true),
          _createTextVNode(" " + _toDisplayString(_ctx.maxMinCalc(scope.row, 'min')), 1)
        ])
      ]),
      _: 1
    }, 8, ["dataList", "total", "page", "size", "columnAllData", "tableName", "permissionName", "onCommandChange"])), [
      [_directive_loading, _ctx.listLoading]
    ])
  ]))
}